import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import "yet-another-react-lightbox/plugins/counter.css";

const floorPlansData = [
  {
    id: "east-cyber",
    title: "East Facing Villa",
    direction: "East",
    images: [
      { src: "/cyber-floor-plans-images/east-cyber/cyber-East.png", label: "3D View" },
      { src: "/cyber-floor-plans-images/east-cyber/cyber-East-ground.jpg", label: "Ground Floor" },
      { src: "/cyber-floor-plans-images/east-cyber/cyber-East-first.jpg", label: "First Floor" },
      { src: "/cyber-floor-plans-images/east-cyber/cyber-East-second.jpg", label: "Second Floor" },
    ],
  },
  {
    id: "west-cyber",
    title: "West Facing Villa",
    direction: "West",
    images: [
      { src: "/cyber-floor-plans-images/west-cyber/cyber-West.png", label: "3D View" },
      { src: "/cyber-floor-plans-images/west-cyber/cyber-West-ground.jpg", label: "Ground Floor" },
      { src: "/cyber-floor-plans-images/west-cyber/cyber-West-first.jpg", label: "First Floor" },
      { src: "/cyber-floor-plans-images/west-cyber/cyber-West-second.jpg", label: "Second Floor" },
    ],
  },
];

export default function FloorPlansCyber() {
  const [activeTab, setActiveTab] = useState(floorPlansData[0].id);
  const [open, setOpen] = useState(false);
  const [slides, setSlides] = useState([]);
  const [index, setIndex] = useState(0);

  const activePlan = floorPlansData.find((plan) => plan.id === activeTab) || floorPlansData[0];

  const openGallery = (idx) => {
    setSlides(activePlan.images.map((image) => ({ src: image.src })));
    setIndex(idx);
    setOpen(true);
  };

  return (
    <section className="cyber-floorplans-section" id="cyber-floor-plans">
      <div className="container">
        <motion.div
          className="cyber-floorplans-header"
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.7 }}
        >
          <span className="cyber-floorplans-kicker">Residence Plans</span>
          <div className="cyber-floorplans-title-row">
            <h2>Floor Plans</h2>
            <p>{activePlan.title}</p>
          </div>
        </motion.div>

        <div className="cyber-floorplans-layout">
          <aside className="cyber-floorplans-tabs" aria-label="Cyber Meadows floor plan options">
            {floorPlansData.map((plan) => (
              <button
                key={plan.id}
                type="button"
                className={`cyber-floorplans-tab ${activeTab === plan.id ? "is-active" : ""}`}
                onClick={() => setActiveTab(plan.id)}
                aria-pressed={activeTab === plan.id}
              >
                <span>{plan.direction}</span>
                <small>Facing Villa</small>
              </button>
            ))}
          </aside>

          <div className="cyber-floorplans-gallery">
            <AnimatePresence mode="wait">
              <motion.div
                key={activePlan.id}
                className="cyber-floorplans-grid"
                initial={{ opacity: 0, y: 18 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -18 }}
                transition={{ duration: 0.35 }}
              >
                {activePlan.images.map((image, idx) => (
                  <motion.button
                    key={`${activePlan.id}-${image.label}`}
                    type="button"
                    className="cyber-floorplan-card"
                    onClick={() => openGallery(idx)}
                    whileHover={{ y: -6 }}
                    transition={{ duration: 0.25 }}
                  >
                    <span className="cyber-floorplan-media">
                      <img
                        src={image.src}
                        alt={`${activePlan.title} ${image.label}`}
                        loading="lazy"
                      />
                      <span className="cyber-floorplan-number">
                        {String(idx + 1).padStart(2, "0")}
                      </span>
                    </span>
                    <span className="cyber-floorplan-copy">
                      <span>{image.label}</span>
                      <small>View Plan</small>
                    </span>
                  </motion.button>
                ))}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={slides}
        index={index}
        plugins={[Zoom, Counter, Fullscreen]}
        imageFit="contain"
        zoom={{
          maxZoomPixelRatio: 4,
          zoomInMultiplier: 1.5,
          doubleTapDelay: 300,
          doubleClickDelay: 300,
        }}
        on={{ view: ({ index: currentIndex }) => setIndex(currentIndex) }}
        counter={{
          container: {
            style: { top: "16px", left: "16px", right: "auto", bottom: "auto", fontSize: "14px" },
          },
        }}
        styles={{ container: { backgroundColor: "rgba(18,15,12,0.96)" } }}
      />
    </section>
  );
}
